module.exports = __webpack_public_path__ + "img/tesla_1248.6acbd840.png";